import { Box, Typography, IconButton, makeStyles } from "@material-ui/core";
import { useContext, useState } from "react";
import {
  Route,
  Link,
  Navigate,
  useLocation,
  useNavigate,
  Routes,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";
import Axios from "axios";

import { UserContext } from "../../contexts/UserContext";
import { useToast } from "../../components/shared/Toast";

import { AddService } from "./addservice";
import { UpdateService } from "./updateservice";
import { AllServices } from "./allservices";
import { AllTestimonials } from "./alltestimonials";
import { AllContacts } from "./allcontacts";
import { AllMetadata } from "./allmetadatas";
import { UpdateMetaData } from "./updatemetadata";
import { AllClients } from "./allclients";
import { AddClient } from "./addClient";
import { AllTeam } from "./allteam";
import { AddTeam } from "./addteam";
import { UpdateTeam } from "./updateteam";
import { AllBanners } from "./allbanners";
import { AddBanner } from "./addbanner";
import { UpdateBanner } from "./updatebanners";
import { EditFeedback } from "./editfeedback";
import { UpdateClient } from "./updateclient";
import { UpdateAboutUs } from "./updateaboutus";
import { AddArticle } from "./addArticle";
import { EditArticle } from "./EditArticle";
import { AllArticles } from "./allArtcles";
import { EnrolledStudents } from "./enrolled_students";

import SchoolOutlinedIcon from "@material-ui/icons/SchoolOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import BuildOutlinedIcon from "@material-ui/icons/BuildOutlined";
import LabelOutlinedIcon from "@material-ui/icons/LabelOutlined";
import FormatQuoteOutlinedIcon from "@material-ui/icons/FormatQuote";
import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ImageOutlinedIcon from "@material-ui/icons/ImageOutlined";
import ArticleOutlinedIcon from "@material-ui/icons/Description";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const NAV_ITEMS = [
  { path: "/dash/enrolled_students", label: "Enrolled Students", icon: SchoolOutlinedIcon },
  { path: "/dash/allcontacts", label: "Contact History", icon: ContactPhoneOutlinedIcon },
  { path: "/dash/allservices", label: "Services", icon: BuildOutlinedIcon },
  { path: "/dash/allmetadatas", label: "Metadata", icon: LabelOutlinedIcon },
  { path: "/dash/alltestimonials", label: "Testimonials", icon: FormatQuoteOutlinedIcon },
  { path: "/dash/allclients", label: "Clients", icon: GroupOutlinedIcon },
  { path: "/dash/team", label: "Team", icon: PeopleAltOutlinedIcon },
  { path: "/dash/banners", label: "Banners", icon: ImageOutlinedIcon },
  { path: "/dash/allarticles", label: "Articles", icon: ArticleOutlinedIcon },
  { path: "/dash/updateaboutus", label: "About Us", icon: InfoOutlinedIcon },
];

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: "100vh",
    background: "#fafafa",
    display: "flex",
  },

  // ── Sidebar ──
  sidebar: {
    width: 280,
    flexShrink: 0,
    background:
      "linear-gradient(180deg, #1a001a 0%, #2d002d 60%, #1a001a 100%)",
    color: "#ffffff",
    display: "flex",
    flexDirection: "column",
    position: "sticky",
    top: 0,
    height: "100vh",
    overflowY: "auto",
    overflowX: "hidden",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      left: 0,
      top: 0,
      bottom: 0,
      zIndex: 50,
      transform: "translateX(-100%)",
      transition: "transform 0.35s cubic-bezier(0.22, 1, 0.36, 1)",
      boxShadow: "0 0 40px rgba(0,0,0,0.4)",
    },
  },
  sidebarOpen: {
    [theme.breakpoints.down("sm")]: {
      transform: "translateX(0)",
    },
  },
  sidebarHeader: {
    padding: "22px 22px 16px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    borderBottom: "1px solid rgba(255,255,255,0.06)",
  },
  brandLogo: {
    width: 38,
    height: 38,
    borderRadius: 10,
    overflow: "hidden",
    background: "rgba(255,255,255,0.94)",
    padding: 4,
    flexShrink: 0,
  },
  brandLogoImg: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    border: "none",
    display: "block",
  },
  brandTitle: {
    fontSize: "0.92rem",
    fontWeight: 700,
    color: "#ffffff",
    letterSpacing: "-0.01em",
    lineHeight: 1.2,
  },
  brandSubtitle: {
    fontSize: "0.62rem",
    fontWeight: 600,
    color: "#c77dc7",
    textTransform: "uppercase",
    letterSpacing: "1.6px",
    marginTop: 2,
  },
  userCard: {
    margin: "16px 18px",
    padding: "14px 16px",
    borderRadius: 14,
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.08)",
    backdropFilter: "blur(10px)",
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  userAvatar: {
    width: 38,
    height: 38,
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, #c77dc7 0%, #9b3b9b 60%, #4c004c 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#ffffff",
    fontSize: "0.92rem",
    fontWeight: 700,
    flexShrink: 0,
    textTransform: "uppercase",
    boxShadow: "0 4px 14px rgba(155,59,155,0.4)",
  },
  userInfo: {
    flex: 1,
    minWidth: 0,
  },
  userName: {
    fontSize: "0.84rem",
    fontWeight: 600,
    color: "#ffffff",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  userMeta: {
    fontSize: "0.66rem",
    color: "#c77dc7",
    marginTop: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  navList: {
    flex: 1,
    padding: "8px 14px 14px",
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },
  navSectionLabel: {
    fontSize: "0.6rem",
    fontWeight: 700,
    color: "rgba(199,125,199,0.7)",
    textTransform: "uppercase",
    letterSpacing: "1.6px",
    padding: "10px 12px 6px",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 14px",
    borderRadius: 11,
    color: "rgba(255,255,255,0.78)",
    fontSize: "0.82rem",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.25s cubic-bezier(0.22, 1, 0.36, 1)",
    "&, &:hover, &:focus, &:active, &:visited": {
      textDecoration: "none",
      color: "rgba(255,255,255,0.78)",
    },
    "&:hover": {
      background: "rgba(255,255,255,0.06)",
      color: "#ffffff",
    },
    "&:hover $navIcon": {
      color: "#e0b8e0",
    },
  },
  navItemActive: {
    background:
      "linear-gradient(135deg, rgba(199,125,199,0.22), rgba(76,0,76,0.32))",
    border: "1px solid rgba(199,125,199,0.32)",
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#ffffff",
    },
    "& $navIcon": {
      color: "#e0b8e0",
    },
  },
  navIcon: {
    fontSize: 18,
    color: "rgba(199,125,199,0.7)",
    transition: "color 0.25s ease",
    flexShrink: 0,
  },

  sidebarFooter: {
    padding: "14px 18px 22px",
    borderTop: "1px solid rgba(255,255,255,0.06)",
  },
  logoutBtn: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    padding: "10px 14px",
    borderRadius: 11,
    background: "rgba(220,38,38,0.1)",
    border: "1px solid rgba(220,38,38,0.22)",
    color: "#fca5a5",
    fontSize: "0.8rem",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.25s ease",
    "&:hover": {
      background: "rgba(220,38,38,0.2)",
      borderColor: "rgba(220,38,38,0.4)",
      color: "#fecaca",
    },
    "& svg": { fontSize: 16 },
  },

  // ── Main content ──
  main: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
  },
  topbar: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    background: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(20px) saturate(180%)",
    WebkitBackdropFilter: "blur(20px) saturate(180%)",
    borderBottom: "1px solid rgba(76,0,76,0.06)",
    padding: "16px 28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    [theme.breakpoints.down("sm")]: {
      padding: "12px 16px",
    },
  },
  topbarLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0,
    flex: 1,
  },
  topbarTitle: {
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "#1a1a1a",
    letterSpacing: "-0.01em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  topbarSubtitle: {
    fontSize: "0.7rem",
    color: "#9b3b9b",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "1.2px",
    marginTop: 2,
  },
  mobileMenuBtn: {
    color: "#4c004c",
    background: "rgba(76,0,76,0.06)",
    border: "1px solid rgba(76,0,76,0.12)",
    borderRadius: 10,
    width: 38,
    height: 38,
    "&:hover": {
      background: "rgba(76,0,76,0.12)",
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  mobileBackdrop: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      position: "fixed",
      inset: 0,
      background: "rgba(26,0,26,0.55)",
      backdropFilter: "blur(4px)",
      zIndex: 40,
      opacity: 0,
      pointerEvents: "none",
      transition: "opacity 0.3s ease",
    },
  },
  mobileBackdropOpen: {
    [theme.breakpoints.down("sm")]: {
      opacity: 1,
      pointerEvents: "auto",
    },
  },
  content: {
    flex: 1,
    padding: "28px 28px 60px",
    [theme.breakpoints.down("sm")]: {
      padding: "20px 16px 40px",
    },
  },
  contentCard: {
    background: "#ffffff",
    borderRadius: 18,
    border: "1px solid rgba(76,0,76,0.06)",
    boxShadow: "0 6px 24px rgba(76,0,76,0.05)",
    padding: "24px 26px",
    [theme.breakpoints.down("sm")]: {
      padding: "18px 16px",
      borderRadius: 14,
    },
  },

  // ── Welcome state (when no nested route is active) ──
  welcomeWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "60px 24px",
    minHeight: 360,
  },
  welcomeIcon: {
    width: 64,
    height: 64,
    borderRadius: 18,
    background:
      "linear-gradient(135deg, rgba(199,125,199,0.18), rgba(76,0,76,0.08))",
    border: "1px solid rgba(155,59,155,0.22)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#9b3b9b",
    marginBottom: 20,
    "& svg": { fontSize: 30 },
  },
  welcomeTitle: {
    fontSize: "1.4rem",
    fontWeight: 700,
    color: "#4c004c",
    marginBottom: 6,
    letterSpacing: "-0.01em",
  },
  welcomeSubtitle: {
    fontSize: "0.88rem",
    color: "#666",
    maxWidth: 420,
    lineHeight: 1.6,
  },
}));

const getInitial = (name) =>
  (name || "A").trim().charAt(0).toUpperCase() || "A";

const getCurrentTitle = (pathname) => {
  const item = NAV_ITEMS.find((it) => pathname.startsWith(it.path));
  return item ? item.label : "Dashboard";
};

const Welcome = ({ userName }) => {
  const classes = useStyles();
  return (
    <Box className={classes.welcomeWrap}>
      <Box className={classes.welcomeIcon}>
        <DashboardOutlinedIcon />
      </Box>
      <Typography className={classes.welcomeTitle}>
        {userName ? `Welcome, ${userName.split(" ")[0]}` : "Welcome"}
      </Typography>
      <Typography className={classes.welcomeSubtitle}>
        Pick a section from the sidebar to manage content, view enquiries, or
        update site data.
      </Typography>
    </Box>
  );
};

export const Dash = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, setUser } = useContext(UserContext);
  const toast = useToast();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const isActive = (path) => location.pathname.startsWith(path);
  const closeDrawer = () => setDrawerOpen(false);

  const logout = () => {
    Axios.get("/api/logout", { headers: { headKey: headKey } }).then((res) => {
      if (res.data.status) {
        toast.success(res.data.msg || "Logged out");
        setUser(null);
        navigate("/");
      } else {
        toast.error("Failed to log out");
      }
    });
  };

  const currentTitle = getCurrentTitle(location.pathname);
  const userName = user?.aduser_name || "Admin";
  const userMeta = user?.aduser_mob || "";

  return (
    <Box className={classes.page}>
      <Helmet>
        <title>Admin Dashboard | Arawinz Soft Solutions</title>
      </Helmet>

      {/* Mobile backdrop */}
      <Box
        className={`${classes.mobileBackdrop} ${
          drawerOpen ? classes.mobileBackdropOpen : ""
        }`}
        onClick={closeDrawer}
      />

      {/* Sidebar */}
      <Box
        className={`${classes.sidebar} ${
          drawerOpen ? classes.sidebarOpen : ""
        }`}
      >
        <Box className={classes.sidebarHeader}>
          <Box className={classes.brandLogo}>
            <img
              src="/static/logo.png"
              alt="Arawinz"
              className={classes.brandLogoImg}
            />
          </Box>
          <Box style={{ minWidth: 0 }}>
            <Typography className={classes.brandTitle}>Arawinz</Typography>
            <Typography className={classes.brandSubtitle}>Admin</Typography>
          </Box>
        </Box>

        {user && (
          <Box className={classes.userCard}>
            <Box className={classes.userAvatar}>{getInitial(userName)}</Box>
            <Box className={classes.userInfo}>
              <Typography className={classes.userName}>{userName}</Typography>
              {userMeta && (
                <Typography className={classes.userMeta}>
                  {userMeta}
                </Typography>
              )}
            </Box>
          </Box>
        )}

        <Box className={classes.navList}>
          <Typography className={classes.navSectionLabel}>Manage</Typography>
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={closeDrawer}
                className={`${classes.navItem} ${
                  active ? classes.navItemActive : ""
                }`}
              >
                <Icon className={classes.navIcon} />
                {item.label}
              </Link>
            );
          })}
        </Box>

        <Box className={classes.sidebarFooter}>
          <button
            type="button"
            className={classes.logoutBtn}
            onClick={logout}
          >
            <ExitToAppIcon />
            Sign out
          </button>
        </Box>
      </Box>

      {/* Main */}
      <Box className={classes.main}>
        <Box className={classes.topbar}>
          <Box className={classes.topbarLeft}>
            <IconButton
              className={classes.mobileMenuBtn}
              onClick={() => setDrawerOpen(true)}
              aria-label="Open menu"
            >
              {drawerOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
            <Box style={{ minWidth: 0 }}>
              <Typography className={classes.topbarTitle}>
                {currentTitle}
              </Typography>
              <Typography className={classes.topbarSubtitle}>
                Admin Dashboard
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box className={classes.content}>
          <Box className={classes.contentCard}>
            <Routes>
              <Route
                index
                element={user ? <Welcome userName={userName} /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/enrolled_students"
                element={user ? <EnrolledStudents /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/allservices"
                element={user ? <AllServices /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/alltestimonials"
                element={user ? <AllTestimonials /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/allcontacts"
                element={user ? <AllContacts /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/allmetadatas"
                element={user ? <AllMetadata /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/addservice"
                element={user ? <AddService /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/editservice/:id"
                element={user ? <UpdateService /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/editfeedback/:id"
                element={user ? <EditFeedback /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/editmetadata/:id"
                element={user ? <UpdateMetaData /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/allclients"
                element={user ? <AllClients /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/addclient"
                element={user ? <AddClient /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/updateclient/:id"
                element={user ? <UpdateClient /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/team"
                element={user ? <AllTeam /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/addteam"
                element={user ? <AddTeam /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/updateteam/:id"
                element={user ? <UpdateTeam /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/banners"
                element={user ? <AllBanners /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/addbanner"
                element={user ? <AddBanner /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/updatebanner/:id"
                element={user ? <UpdateBanner /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/updateaboutus"
                element={user ? <UpdateAboutUs /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/allarticles"
                element={user ? <AllArticles /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/add_article"
                element={user ? <AddArticle /> : <Navigate to="/login_ad" />}
              />
              <Route
                path="/edit_articles/:id"
                element={user ? <EditArticle /> : <Navigate to="/login_ad" />}
              />
            </Routes>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
